/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Body/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import MedicalAlertBody from './MedicalAlertBody/index'
import No from './No/index'
import NotesBody from './NotesBody/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Body({
  children,
  viewPath = "/App/Account/PatientNotifications/Content/Content/Content/Alerts/Alert/Body"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let alertTypeValueData = fromData.useDataFormat({ viewPath,
context: 'alert',
path: 'type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: alertTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MedicalAlertBody'}>
<MedicalAlertBody
  viewPath={`${viewPath}/MedicalAlertBody`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NotesBody'}>
<NotesBody
  viewPath={`${viewPath}/NotesBody`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}